import React from 'react';
import BulkRefunds from '../../../components/Refunds/BulkRefunds/BulkRefunds';

const BulkRefundsPage = () => {
  return <BulkRefunds />;
};

export default BulkRefundsPage;
